export { useResolvedTemplate } from './use-resolved-template'
